import React, { memo } from 'react';

import { Box } from '@mui/material';
import PropTypes from 'prop-types';

import {
  FieldTypesEnum,
  mailAddressSourceOptions,
  physicalMailClassOptions,
} from 'constants/loanActionEditor';

import { DynamicValueInput } from '../LoanActionItems';

import { wrapperStyles } from './LoanActionMailDocumentPackageRow.styles';

const emptyOptions = [];

const LoanActionMailDocumentPackageRow = ({
  index,
  rootPath,
  isDisabled = false,
  isEditAllowed,
  formBundlesOptions = emptyOptions,
}) => {
  const fieldPath = `${rootPath}[${index}]`;

  return (
    <Box sx={wrapperStyles}>
      <DynamicValueInput
        required
        className="grow"
        disabled={isDisabled || !isEditAllowed}
        label="Form Bundle"
        name={`${fieldPath}.formBundle`}
        options={formBundlesOptions}
        type={FieldTypesEnum.SELECT}
      />
      <DynamicValueInput
        required
        className="grow"
        disabled={isDisabled || !isEditAllowed}
        label="Mail Class"
        name={`${fieldPath}.mailClass`}
        options={physicalMailClassOptions}
        type={FieldTypesEnum.SELECT}
        withSortedOptions={false}
      />
      <DynamicValueInput
        required
        className="grow"
        disabled={isDisabled || !isEditAllowed}
        label="Address Source"
        name={`${fieldPath}.addressSource`}
        options={mailAddressSourceOptions}
        type={FieldTypesEnum.SELECT}
        withSortedOptions={false}
      />
    </Box>
  );
};

LoanActionMailDocumentPackageRow.propTypes = {
  index: PropTypes.number.isRequired,
  rootPath: PropTypes.string.isRequired,
  isEditAllowed: PropTypes.bool.isRequired,
  isDisabled: PropTypes.bool,
  formBundlesOptions: PropTypes.array,
};

export default memo(LoanActionMailDocumentPackageRow);
